<template>
  <div class="mayday-root" :class="{ 'is-act-ended': isActEnded }">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow00.webp" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules02.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="mayday-main" :style="{ 'margin-top': `-${barHeight + 40}px`, 'padding-top': `${barHeight + 40}px` }">
      <div class="mayday-bg-gradient" />

      <div v-if="!isActEnded" class="mayday-hero-bg">
        <img src="./images/hero-bg.webp" alt="" />
      </div>

      <div v-if="!isActEnded" class="mayday-hero">
        <p class="hero-sub">{{ $t('lang.MayDay2026.k042') }}</p>
        <p class="hero-title">{{ $t('lang.MayDay2026.k043') }}</p>
        <div class="hero-prize">
          <span class="hero-prize-num">{{ boardData.num1Reward }}</span>
          <img class="hero-prize-coin" :src="getMatchImg('coin')" alt="" />
        </div>
        <div class="hero-countdown">
          <img class="hero-cd-icon" src="./images/clock.webp" alt="" />
          <div class="cd-cell">
            <span class="cd-val">{{ countdownResult.days }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k049') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownResult.hours }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k060') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownResult.minutes }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k061') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownResult.seconds }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k062') }}</span>
          </div>
        </div>
      </div>

      <div class="mayday-scroll">
        <div v-if="!isActEnded" class="segment-tabs">
          <div class="segment-inner" :class="{ 'segment-flow-locked': spinFlowActive }">
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'wheel' }" @click="switchPage('wheel')">
              {{ $t('lang.MayDay2026.k030') }}
            </div>
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'rank' }" @click="switchPage('rank')">
              {{ $t('lang.MayDay2026.k031') }}
            </div>
          </div>
        </div>

        <!-- Luck Draw -->
        <div v-show="!isActEnded && mainSegment === 'wheel'" class="mayday-wheel-segment">
          <div class="card lucky-card">
            <div class="card-head">
              <div class="card-head-left">
                <img class="ic-star" src="./images/star.webp" alt="" />
                <span>{{ $t('lang.MayDay2026.k017') }}</span>
              </div>
              <img v-if="hasSpinHistory" class="ic-history" src="./images/ic_refresh.webp" alt="" @click="handleToRecords" />
            </div>

            <div class="pool-switch" :class="{ 'pool-flow-locked': spinFlowActive }">
              <div class="pool-track" />
              <div class="pool-pill" :class="{ 'silver-on': controlWheel.isSwitch === 'silver' }" @click="handleSwitchWheel('silver')">
                {{ $t('lang.MayDay2026.k018') }}
              </div>
              <div class="pool-pill" :class="{ 'gold-on': controlWheel.isSwitch === 'gold' }" @click="handleSwitchWheel('gold')">
                {{ $t('lang.MayDay2026.k019') }}
              </div>
            </div>

            <div class="wheel-stage">
              <div class="wheel-pan mayday-wheel-pan">
                <div class="outher">
                  <div v-if="actInfo" ref="wapper" class="wapper">
                    <div class="part1">
                      <div v-if="panData && panData[0]" class="item one" :class="{ gotted: controlWheel.gotDrawId === panData[0].id }">
                        <div class="text">
                          <template v-if="panData[0].propType === 0">
                            <span class="text-tips">{{ panData[0].count }}</span>
                            <img v-if="panData[0].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[0].count }}</span>
                            <img v-if="panData[0].propType !== 10" :src="resolveMatchImg(panData[0].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[1]" class="item two" :class="{ gotted: controlWheel.gotDrawId === panData[1].id }">
                        <div class="text">
                          <template v-if="panData[1].propType === 0">
                            <span class="text-tips">{{ panData[1].count }}</span>
                            <img v-if="panData[1].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[1].count }}</span>
                            <img v-if="panData[1].propType !== 10" :src="resolveMatchImg(panData[1].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[2]" class="item three" :class="{ gotted: controlWheel.gotDrawId === panData[2].id }">
                        <div class="text">
                          <template v-if="panData[2].propType === 0">
                            <span class="text-tips">{{ panData[2].count }}</span>
                            <img v-if="panData[2].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[2].count }}</span>
                            <img v-if="panData[2].propType !== 10" :src="resolveMatchImg(panData[2].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[3]" class="item four" :class="{ gotted: controlWheel.gotDrawId === panData[3].id }">
                        <div class="text">
                          <template v-if="panData[3].propType === 0">
                            <span class="text-tips">{{ panData[3].count }}</span>
                            <img v-if="panData[3].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[3].count }}</span>
                            <img v-if="panData[3].propType !== 10" :src="resolveMatchImg(panData[3].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="part2">
                      <div v-if="panData && panData[4]" class="item five" :class="{ gotted: controlWheel.gotDrawId === panData[4].id }">
                        <div class="text">
                          <template v-if="panData[4].propType === 0">
                            <span class="text-tips">{{ panData[4].count }}</span>
                            <img v-if="panData[4].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[4].count }}</span>
                            <img v-if="panData[4].propType !== 10" :src="resolveMatchImg(panData[4].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[5]" class="item six" :class="{ gotted: controlWheel.gotDrawId === panData[5].id }">
                        <div class="text">
                          <template v-if="panData[5].propType === 0">
                            <span class="text-tips">{{ panData[5].count }}</span>
                            <img v-if="panData[5].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[5].count }}</span>
                            <img v-if="panData[5].propType !== 10" :src="resolveMatchImg(panData[5].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[6]" class="item seven" :class="{ gotted: controlWheel.gotDrawId === panData[6].id }">
                        <div class="text">
                          <template v-if="panData[6].propType === 0">
                            <span class="text-tips">{{ panData[6].count }}</span>
                            <img v-if="panData[6].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[6].count }}</span>
                            <img v-if="panData[6].propType !== 10" :src="resolveMatchImg(panData[6].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[7]" class="item eight" :class="{ gotted: controlWheel.gotDrawId === panData[7].id }">
                        <div class="text">
                          <template v-if="panData[7].propType === 0">
                            <span class="text-tips">{{ panData[7].count }}</span>
                            <img v-if="panData[7].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[7].count }}</span>
                            <img v-if="panData[7].propType !== 10" :src="resolveMatchImg(panData[7].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wheel-pointer mayday-wheel-pointer" />
              </div>
              <div class="podium-deco">
                <img class="podium" src="./images/pan.webp" alt="" />
              </div>
            </div>

            <div class="ticket-row">
              <img class="tic" src="./images/ic_ticket.webp" alt="" />
              <span class="tic-x">x{{ actInfo && actInfo.ticketBalance != null ? actInfo.ticketBalance : 0 }}</span>
              <div class="tic-div"></div>
              <span class="tic-txt">{{ controlWheel.restSpins || 0 }} {{ $t('lang.MayDay2026.k040') }}</span>
            </div>

            <div class="spin-btn-row">
              <!-- Spin x1 -->
              <div class="spin-pill-wrap">
                <div
                  class="spin-pill spin-pill-primary"
                  :class="{
                    'silver-on': controlWheel.isSwitch === 'silver',
                    'gold-on': controlWheel.isSwitch === 'gold',
                    'spin-off': !spinCanX1,
                  }"
                  @click="handleWheelPan(1)"
                >
                  <span class="spin-pill-t">{{ $t('lang.MayDay2026.k020') }} x1</span>
                  <span class="spin-pill-sub">
                    <b>{{ poolSpinCost }}</b>
                    <img src="./images/ic_ticket.webp" alt="" class="sub-tic" />
                  </span>
                </div>
                <div
                  class="spin-pill-shadow"
                  :class="{
                    silver: controlWheel.isSwitch === 'silver',
                    gold: controlWheel.isSwitch === 'gold',
                    off: !spinCanX1,
                  }"
                />
              </div>
              <!-- Spin x10 -->
              <div class="spin-pill-wrap">
                <div
                  class="spin-pill spin-pill-primary"
                  :class="{
                    'silver-on': controlWheel.isSwitch === 'silver',
                    'gold-on': controlWheel.isSwitch === 'gold',
                    'spin-off': !spinCanX10,
                  }"
                  @click="handleWheelPan(10)"
                >
                  <span class="spin-pill-t">{{ $t('lang.MayDay2026.k020') }} x10</span>
                  <span class="spin-pill-sub">
                    <b>{{ poolSpinCost * 10 }}</b>
                    <img src="./images/ic_ticket.webp" alt="" class="sub-tic" />
                  </span>
                </div>
                <div
                  class="spin-pill-shadow"
                  :class="{
                    silver: controlWheel.isSwitch === 'silver',
                    gold: controlWheel.isSwitch === 'gold',
                    off: !spinCanX10,
                  }"
                />
              </div>
            </div>
          </div>

          <!-- Ways to earn -->
          <div id="tasks-anchor" ref="tasksAnchor" class="card ways-card">
            <div class="card-head">
              <div class="card-head-left">
                <img class="ic-star" src="./images/star.webp" alt="" />
                <span>{{ $t('lang.MayDay2026.k032') }}</span>
              </div>
            </div>
            <div class="ways-body">
              <div v-if="actInfo" class="stats-bar">
                <div class="stats-left">
                  <div class="stat">
                    <img src="./images/ic_point.webp" alt="" />
                    <span>{{ actInfo.score || 0 }}</span>
                  </div>
                  <div class="stat">
                    <img src="./images/cup.webp" alt="" />
                    <span>{{ statsBarRankCupLabel }}</span>
                  </div>
                </div>
                <div class="stats-rank-link" @click="switchPage('rank')">
                  {{ $t('lang.MayDay2026.k039') }}
                  <img src="./images/chevron-rank.webp" alt="" />
                </div>
              </div>

              <div v-if="dailyTasksList.length" class="task-block task-block-daily">
                <p class="task-block-title">{{ $t('lang.MayDay2026.k033') }}</p>
                <p class="task-block-sub">{{ $t('lang.MayDay2026.k034') }}</p>
                <!-- Daily Tasks -->
                <div v-for="(dt, di) in dailyTasksList" :key="dt.id || di" class="task-row">
                  <div class="task-row-main">
                    <div class="task-desc task-desc-plain">
                      <MyPLabel class="task-desc" :str="dt.title" :numsOption="dt.numsOption || [{ value: 20 }]" />
                      <span class="task-desc-proc">&nbsp;({{ dt.proc }}/{{ dt.target }})</span>
                    </div>
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in dt.rewards" :key="'d' + di + '-' + ri" class="task-reward-item">
                        <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                        <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                        <span>+{{ r.value }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="Number(dt.state) === 0" class="task-go" @click="appAction(dt.action)">
                    {{ $t('lang.MayDay2026.k029') }}
                  </div>
                  <div v-else class="task-btn-wait">
                    <!-- prettier-ignore -->
                    <template v-if="dailyCountdownObj && dailyCountdownObj.countdownResult">
                      {{ dailyCountdownObj.countdownResult.hours }}:{{ dailyCountdownObj.countdownResult.minutes }}:{{dailyCountdownObj.countdownResult.seconds}}
                    </template>
                    <template v-else>00:00:00</template>
                  </div>
                </div>
              </div>

              <div v-if="streakTasksList.length" class="task-block task-block-streak">
                <p class="task-block-title">{{ $t('lang.MayDay2026.k035') }}</p>
                <p class="task-block-sub">{{ $t('lang.MayDay2026.k036') }}</p>
                <!-- Streak Tasks -->
                <div v-for="(st, si) in streakTasksList" :key="st.id || si" class="task-row task-row-streak">
                  <div class="task-row-main">
                    <div class="task-streak-head">
                      <MyPLabel class="task-desc streak-task-title" :str="st.title" :numsOption="st.numsOption || [{ value: 20 }]" />
                    </div>
                    <div class="task-streak-bar-row">
                      <div class="task-streak-bar">
                        <div class="task-streak-bar-fill" :style="{ width: streakBarPercent(st) }" />
                      </div>
                      <span class="task-streak-progress" :class="{ 'is-done': streakProgressDone(st) }">({{ st.proc }}/{{ st.target }})</span>
                    </div>
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in st.rewards || []" :key="ri" class="task-reward-item">
                        <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                        <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                        <span>+{{ r.value }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="streakSideButtonUi(st) === 'go'" class="task-go" @click="appAction(st.action)">
                    {{ $t('lang.MayDay2026.k029') }}
                  </div>
                  <template v-else>
                    <div v-if="streakSideButtonUi(st) === 'wait'" class="task-btn-wait">
                      <!-- prettier-ignore -->
                      <template v-if="dailyCountdownObj && dailyCountdownObj.countdownResult">{{ dailyCountdownObj.countdownResult.hours }}:{{ dailyCountdownObj.countdownResult.minutes }}:{{dailyCountdownObj.countdownResult.seconds}}</template>
                      <template v-else>00:00:00</template>
                    </div>
                    <div v-else class="task-streak-done">
                      <img src="./images/claimed.webp" alt="" width="24" height="24" />
                    </div>
                  </template>
                </div>
              </div>

              <div class="task-block">
                <p class="task-block-title">{{ $t('lang.MayDay2026.k037') }}</p>
                <p class="task-block-sub">{{ $t('lang.MayDay2026.k038') }}</p>
                <!-- Repeatable Tasks -->
                <div v-for="(task, idx) in repeatableTasksList" :key="idx" class="task-row">
                  <div class="task-row-main">
                    <MyPLabel class="task-desc" :str="task.title" :numsOption="task.numsOption || [{ value: 20 }]" />
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in task.rewards" :key="ri" class="task-reward-item">
                        <template v-if="r.value">
                          <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                          <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                          <span>+{{ r.value }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="task-go" @click="appAction(task.action)">{{ $t('lang.MayDay2026.k029') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <act-male-rank v-if="isActEnded || mainSegment === 'rank'" @go-earn="onGoEarnFromRank" />
      </div>
    </div>

    <div v-if="showSuccess" class="act-mask">
      <div class="dia-bg">
        <div class="con-block">
          <div class="gifts-dia-head">
            <span>{{ $t('lang.MayDay2026.k023') }}</span>
          </div>
          <div v-if="showSuccess === 1" class="gifts-reward1">
            <div v-for="reward in rewards" :key="reward.id" class="gifts-reward1-cell">
              <div class="img-wrap">
                <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
              </div>
              <div class="rewards-count">x{{ reward.count }}</div>
            </div>
          </div>

          <div v-else class="gifts-reward2">
            <div
              v-for="(reward, rewardIdx) in rewards"
              :key="reward.id"
              class="gifts-reward2-cell gifts-reward2-cell--stagger"
              :style="{ animationDelay: `${rewardIdx * 40}ms` }"
            >
              <div class="img-wrap">
                <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
              </div>
              <div class="rewards-count">x{{ reward.count }}</div>
            </div>
          </div>

          <div class="gifts-confirm" @click="showSuccess = 0">
            <span>{{ $t('lang.ActCommon.k100') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maleSpinHome, maleSpinDraw, newSpinIdempotencyKey } from './apidir/api.js'
import {
  normalizeMaleSpinHome,
  mapApiTasksToRows,
  mapSpinResultsToPanRewards,
  matchWheelSliceId,
  mapDrawOptionRewardsToPan,
  mapSilverDrawOptionRewardsToPan,
} from './utils/maleSpinAdapter.js'

import countDown from '@/mixin/count-down.js'
import scrollMixin from '@/mixin/index.js'
import CountDownClass from '@/utils/count-down.js'
import ActMaleRank from './actMaleRank.vue'

const angles = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]

export default {
  mixins: [countDown, scrollMixin],
  components: {
    ActMaleRank,
  },
  data() {
    return {
      mainSegment: 'wheel',
      actInfo: null,
      isWheeling: false,
      isPosting: false,
      controlWheel: {
        isSwitch: 'silver',
        gotDrawId: null,
        restSpins: 0,
      },
      panData: null,
      boardData: {
        num1Reward: 2000,
      },
      showSuccess: 0,
      rewards: [],
      dailyCountdownObj: null,
      /** maleSpin /home 原始 tasks，用于计算任务列表 */
      spinTasksFromApi: null,
      /** App WebView：是否曾进入后台，用于回到前台时只刷新一次 */
      _spinPageWasHidden: false,
      /** 回到前台时若正在转盘/请求中，结束后补一次刷新 */
      _pendingResumeRefresh: false,
    }
  },
  watch: {
    isWheeling(val) {
      if (!val) this.tryFlushPendingResumeRefresh()
    },
    isPosting(val) {
      if (!val) this.tryFlushPendingResumeRefresh()
    },
  },
  computed: {
    isActEnded() {
      if (!this.actInfo) return false
      const st = this.actInfo.eventStatus
      if (st === 'CLOSED' || st === 'SETTLING') return true
      if (Number(this.actInfo.countdown) <= 0) return true
      const cr = this.countdownResult
      if (cr && typeof cr.days !== 'undefined' && cr.days === '00' && cr.hours === '00' && cr.minutes === '00' && cr.seconds === '00') {
        return true
      }
      return false
    },
    hasSpinHistory() {
      return this.actInfo && this.actInfo.hasSpinHistory
    },
    dailyTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.dailyTasks) return []
      return mapApiTasksToRows(tasks.dailyTasks, this.$t.bind(this), 'daily')
    },
    streakTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.streakTasks) return []
      return mapApiTasksToRows(tasks.streakTasks, this.$t.bind(this), 'streak')
    },
    repeatableTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.repeatableTasks) return []
      return mapApiTasksToRows(tasks.repeatableTasks, this.$t.bind(this), 'repeatable')
    },
    /** 当前奖池 drawOptions（silver / gold） */
    currentPoolDrawOpt() {
      if (!this.actInfo || !this.actInfo.drawOptions) return null
      const key = this.controlWheel.isSwitch === 'gold' ? 'gold' : 'silver'
      return this.actInfo.drawOptions[key] || null
    },
    /** 单次抽奖消耗的 ticket 数（接口 cost） */
    poolSpinCost() {
      const opt = this.currentPoolDrawOpt
      if (opt && opt.cost != null) return Number(opt.cost) || 0
      const w =
        this.controlWheel.isSwitch === 'gold' ? this.actInfo && this.actInfo.advancedPrizeWheel : this.actInfo && this.actInfo.normalPrizeWheel
      return Number(w && w.costPoint) || 1
    },
    spinCanX1() {
      const opt = this.currentPoolDrawOpt
      if (opt) return !!opt.canSpinX1
      return (Number(this.controlWheel.restSpins) || 0) >= 1
    },
    spinCanX10() {
      const opt = this.currentPoolDrawOpt
      if (opt) return !!opt.canSpinX10
      return (Number(this.controlWheel.restSpins) || 0) >= 10
    },
    /** 抽奖页 stats 名次：未上榜 `--`；已上榜超 100 名 `100+`；前 100 展示 `#数字`（逻辑与榜单页 ownerRankDisplay 一致） */
    statsBarRankCupLabel() {
      if (!this.actInfo) return '--'
      const score = Number(this.actInfo.score)
      if (!Number.isFinite(score) || score < 3) return '--'
      const r = this.actInfo.rank
      if (r == null || r === '' || r === '--') return '--'
      const n = Number(r)
      if (!Number.isFinite(n) || n < 1) return '--'
      if (n > 100) return '100+'
      return `#${n}`
    },
    /** 抽奖请求中或转盘转动中：禁止主 Tab / 奖池切换，奖励弹框弹出前保持锁定 */
    spinFlowActive() {
      return this.isPosting || this.isWheeling
    },
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/mayday2026-rules-male', query: { from: 'mayday2026-main-male' } })
    },
    switchPage(arg) {
      if (this.spinFlowActive) return
      this.mainSegment = arg
    },
    /**
     * 从榜单切回抽奖 Tab 后滚到任务区。真机 WebView 上：
     * - 父级 v-show 切为显示前 scrollIntoView 无效
     * - smooth 行为在部分 iOS/WebView 不稳定
     * 故在双 $nextTick + 双 rAF 后用手动 scrollTo，并同步写 documentElement/body
     */
    scrollTasksSectionIntoView() {
      const el = this.$refs.tasksAnchor
      if (!el || typeof el.getBoundingClientRect !== 'function') return
      const rect = el.getBoundingClientRect()
      if (!rect.width && !rect.height) return
      const cur = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const top = Math.max(0, rect.top + cur - 8)
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ left: 0, top, behavior: 'auto' })
        } catch (e) {
          window.scrollTo(0, top)
        }
      }
      document.documentElement.scrollTop = top
      document.body.scrollTop = top
    },
    onGoEarnFromRank() {
      if (this.isActEnded) return
      if (this.spinFlowActive) return
      this.mainSegment = 'wheel'
      this.$nextTick(() => {
        this.$nextTick(() => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.scrollTasksSectionIntoView()
            })
          })
        })
      })
    },
    handleToRecords() {
      this.$router.push({ path: '/mayday2026-records-male', query: { from: 'mayday2026-main-male' } })
    },
    syncDailyCountdown(resData) {
      if (this.dailyCountdownObj && this.dailyCountdownObj.animationFrameId) {
        cancelAnimationFrame(this.dailyCountdownObj.animationFrameId)
        this.dailyCountdownObj.animationFrameId = null
      }
      this.dailyCountdownObj = null
      const sec = Number(resData.dailyCountdown)
      if (sec > 0) {
        this.dailyCountdownObj = new CountDownClass()
        this.dailyCountdownObj.initCountDown(sec, 'HMS')
      }
    },
    streakBarPercent(st) {
      const p = Number(st && st.proc)
      const t = Number(st && st.target)
      if (!t || Number.isNaN(t)) return '0%'
      const pct = Math.min(100, Math.max(0, Math.round(((Number.isNaN(p) ? 0 : p) / t) * 100)))
      return `${pct}%`
    },
    streakProgressDone(st) {
      const p = Number(st && st.proc)
      const t = Number(st && st.target)
      if (!t || Number.isNaN(t)) return false
      return (Number.isNaN(p) ? 0 : p) >= t
    },
    /**
     * Streak 右侧按钮：仅用 proc/target
     * proc 为 0：Go；介于 1 与 target-1：次日倒计时；达到 target：✅
     */
    streakSideButtonUi(st) {
      const t = Number(st && st.target)
      const p = Number(st && st.proc)
      if (!Number.isFinite(t) || t <= 0) return 'go'
      const pv = Number.isFinite(p) ? p : 0
      if (pv >= t) return 'done'
      if (pv > 0) return 'wait'
      return 'go'
    },
    handleSwitchWheel(type) {
      if (this.spinFlowActive) return
      const poolKey = type === 'gold' ? 'gold' : 'silver'
      const opt = this.actInfo && this.actInfo.drawOptions && this.actInfo.drawOptions[poolKey]
      if (opt) {
        this.controlWheel.restSpins = Number(opt.availableSpins) || 0
        const fromDraw = type === 'silver' ? mapSilverDrawOptionRewardsToPan(opt.rewards) : mapDrawOptionRewardsToPan(opt.rewards)
        this.panData = fromDraw.length ? fromDraw : []
        if (!this.panData.length) {
          const w = type === 'gold' ? this.actInfo.advancedPrizeWheel : this.actInfo.normalPrizeWheel
          this.panData = (w && w.rewards) || []
        }
      } else {
        if (type === 'silver' && this.actInfo && this.actInfo.normalPrizeWheel) {
          this.controlWheel.restSpins = this.actInfo.normalPrizeWheel.restSpins || 0
          this.panData = this.actInfo.normalPrizeWheel.rewards
        }
        if (type === 'gold' && this.actInfo && this.actInfo.advancedPrizeWheel) {
          this.controlWheel.restSpins = this.actInfo.advancedPrizeWheel.restSpins || 0
          this.panData = this.actInfo.advancedPrizeWheel.rewards || []
        }
      }
      this.controlWheel.isSwitch = type
    },
    resolveMatchImg(propType) {
      if (this.propsMap[propType]) {
        return this.getMatchImg(this.propsMap[propType])
      }
      return ''
    },
    handleWheelPan(spinCount) {
      const poolKey = this.controlWheel.isSwitch === 'gold' ? 'gold' : 'silver'
      const opt = this.actInfo && this.actInfo.drawOptions && this.actInfo.drawOptions[poolKey]
      let canSpin = false
      if (opt) {
        canSpin = spinCount === 1 ? !!opt.canSpinX1 : !!opt.canSpinX10
      } else {
        const spins = Number(this.controlWheel.restSpins) || 0
        canSpin = (spinCount === 1 && spins >= 1) || (spinCount === 10 && spins >= 10)
      }
      if (!canSpin) {
        return
      }

      if (!this.isWheeling) {
        this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'may-day-spin' })
        this.controlWheel.gotDrawId = null
        this.$nextTick(() => {
          if (this.isPosting) {
            return
          }
          this.isPosting = true
          const poolType = poolKey === 'gold' ? 'GOLD' : 'SILVER'
          maleSpinDraw({
            poolType,
            spinCount,
            idempotencyKey: newSpinIdempotencyKey(),
          })
            .then((resData) => {
              if (resData && !resData.error && resData.results && resData.results.length) {
                const panRewards = mapSpinResultsToPanRewards(resData.results)
                const finish = () => {
                  this.rewards = panRewards
                  this.showSuccess = resData.results.length >= 10 ? 10 : 1
                  this.fetchBaseData(() => this.handleSwitchWheel(this.controlWheel.isSwitch))
                }
                if (resData.results.length === 1) {
                  const gotId = matchWheelSliceId(this.panData, resData.results[0])
                  this.resolveData(gotId, () => {
                    this.controlWheel.gotDrawId = gotId
                    finish()
                  })
                } else {
                  this.resolveData('x10', finish)
                }
              }
            })
            .finally(() => {
              this.isPosting = false
            })
        })
      }
    },
    resolveData(gotDrawId, cbFn) {
      if (gotDrawId === 'x10') {
        this.doWheelPan(0, cbFn, 20)
        return
      }

      const tempArr = this.panData || []
      const originIndex = tempArr.findIndex((item) => item.id === gotDrawId)
      if (originIndex > -1) {
        this.doWheelPan(angles[originIndex], cbFn, 100)
      } else {
        this.doWheelPan(0, cbFn, 20)
      }
    },
    doWheelPan(angle, fn, interval = 50) {
      this.isWheeling = true

      let begin = 0
      const basic = 1800

      const timer = setInterval(() => {
        if (begin > basic + angle) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
        const wrap = this.$refs.wapper
        if (wrap) wrap.style.transform = 'rotate(' + begin + 'deg)'
        begin += Math.ceil(basic + angle - begin) * 0.1
      }, interval)
    },
    fetchBaseData(cbFn) {
      maleSpinHome().then((raw) => {
        if (raw && !raw.error) {
          this.spinTasksFromApi = raw.tasks || null
          this.actInfo = normalizeMaleSpinHome(raw)
          if (!this.actInfo) return
          if (this.actInfo.endTimestamp) {
            this.initCountDown(this.actInfo.endTimestamp, true, true)
          }
          this.syncDailyCountdown(this.actInfo)
          cbFn && cbFn()
        }
      })
    },
    refresh() {
      this.fetchBaseData(() => this.handleSwitchWheel(this.controlWheel.isSwitch))
    },
    /** App 内嵌：从后台回到前台时拉取最新活动数据 */
    handleVisibilityChange() {
      const state = document.visibilityState || document.webkitVisibilityState || document.mozVisibilityState || 'visible'
      if (state === 'hidden') {
        this._spinPageWasHidden = true
        return
      }
      if (state !== 'visible' || !this._spinPageWasHidden) {
        return
      }
      this._spinPageWasHidden = false
      if (this.isWheeling || this.isPosting) {
        this._pendingResumeRefresh = true
        return
      }
      this.refresh()
    },
    tryFlushPendingResumeRefresh() {
      if (!this._pendingResumeRefresh || this.isWheeling || this.isPosting) return
      this._pendingResumeRefresh = false
      this.refresh()
    },
  },
  created() {
    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'may-day' })
    this.fetchBaseData(() => {
      const fromApi = this.actInfo && this.actInfo.defaultPool
      if (fromApi === 'gold' || fromApi === 'silver') {
        this.handleSwitchWheel(fromApi)
        return
      }
      const silverSpins = (this.actInfo && this.actInfo.normalPrizeWheel && this.actInfo.normalPrizeWheel.restSpins) || 0
      const defaultPool = silverSpins >= 10 ? 'gold' : 'silver'
      this.handleSwitchWheel(defaultPool)
    })
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    if (this.dailyCountdownObj && this.dailyCountdownObj.animationFrameId) {
      cancelAnimationFrame(this.dailyCountdownObj.animationFrameId)
    }
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

/* 样式按 template 树形结构嵌套，与 DOM 顺序一致 */
.mayday-root {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(179.95deg, #0da1fe 0%, #37def9 30.43%, #dbfffd 67.4%);

  &.is-act-ended {
    .mayday-scroll {
      padding-top: 8px;
    }
  }

  .custom-nav-block {
    background: rgba(60, 175, 246);

    ::v-deep .van-bar.van-nav-bar {
      background: transparent;
    }
    ::v-deep .van-bar .van-nav-bar__title {
      color: #fff;
    }
    ::v-deep .van-bar .van-icon {
      color: #fff;
    }
  }

  .mayday-main {
    position: relative;

    .mayday-bg-gradient {
      position: fixed;
      inset: 0;
      z-index: 0;
      pointer-events: none;
      background: linear-gradient(179.95deg, #0da1fe 0%, #37def9 30.43%, #dbfffd 67.4%);
    }

    .mayday-hero-bg {
      position: absolute;
      left: 50%;
      top: 0;
      width: 375px;
      height: 427px;
      transform: translateX(-50%);
      z-index: 1;
      pointer-events: none;
      img {
        width: 100%;
      }
    }

    .mayday-hero {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 18px 0 12px;

      .hero-sub {
        margin: 0;
        font-family: 'TikTokSans-Regular', sans-serif;
        font-weight: 900;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
        text-shadow: 2px 2px 0 rgba(17, 95, 173, 0.4);
      }

      .hero-title {
        font-family: 'TikTokSans-Regular', sans-serif;
        font-weight: 900;
        font-size: 40px;
        line-height: 52px;
        text-align: center;
        color: #fff;
        text-shadow: 2px 4px 0 rgba(17, 95, 173, 0.4);
        max-width: 340px;
      }

      .hero-prize {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-left: 16px;

        .hero-prize-num {
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 900;
          font-size: 60px;
          line-height: 78px;
          color: #ffe600;
          text-shadow: 2px 4px 0 rgba(88, 81, 16, 0.3);
        }

        .hero-prize-coin {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
      }

      .hero-countdown {
        margin-top: 12px;
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(2px);

        .hero-cd-icon {
          width: 26px;
          height: 26px;
          margin-right: 8px;
        }

        .cd-cell {
          flex: 1 1 0;
          /* 葡语等「min.」单位明显长于 d/h/s，需保证格内不再挤压 */
          min-width: 40px;
          flex-shrink: 1;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          flex-wrap: nowrap;
          gap: 2px;
          padding: 4px 8px;
          box-sizing: border-box;
          background: #fff;
          border-radius: 4px;
          white-space: nowrap;

          .cd-val {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 14px;
            color: #0081b3;
          }

          .cd-unit {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 700;
            font-size: 11px;
            line-height: 16px;
            color: #26c6fa;
          }
        }

        .cd-colon {
          flex-shrink: 0;
          color: #fff;
          font-weight: 700;
          font-size: 14px;
          margin: 0 3px;
        }
      }
    }

    .mayday-scroll {
      position: relative;
      z-index: 3;
      padding: 0 0 48px;

      .segment-tabs {
        display: flex;
        justify-content: center;
        padding: 12px 0 16px;

        .segment-inner {
          display: flex;
          align-items: center;
          padding: 6px;
          border-radius: 60px;
          background: rgba(48, 137, 170, 0.6);
          backdrop-filter: blur(12px);

          .segment-item {
            min-width: 120px;
            padding: 8px 32px;
            border-radius: 20px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 16px;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            &.segment-active {
              background: #fff;
              color: #0081b3;
            }
          }

          &.segment-flow-locked {
            pointer-events: none;
            opacity: 0.65;
          }
        }
      }

      .card {
        width: 355px;
        margin: 0 auto 16px;
        border-radius: 20px;
        border: 2px solid #fff;
        &.lucky-card {
          background: #f9feff;
        }
        &.ways-card {
          background: #d3f6ff;
        }
      }

      .lucky-card {
        .card-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;

          .card-head-left {
            display: flex;
            align-items: center;
            gap: 8px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 900;
            font-style: italic;
            font-size: 20px;
            line-height: 24px;
            color: #0081b3;

            .ic-star {
              width: 20px;
              height: 20px;
            }
          }

          .ic-history {
            width: 24px;
            height: 24px;
          }
        }

        .pool-switch {
          position: relative;
          display: flex;
          width: 268px;
          margin: 0 auto;
          padding: 4px;
          border-radius: 60px;
          overflow: hidden;

          .pool-track {
            position: absolute;
            inset: 0;
            background: #f0f1f2;
            border-radius: 60px;
            box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.1);
          }

          &.pool-flow-locked {
            pointer-events: none;
            opacity: 0.75;
          }

          .pool-pill {
            position: relative;
            z-index: 1;
            flex: 1;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 20px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 14px;
            color: #5f656a;
            &.silver-on {
              background: linear-gradient(180.68deg, #c01fff 1.6%, #820cff 97.77%);
              color: #fafafa;
            }
            &.gold-on {
              background: linear-gradient(180deg, #ffa903 0.24%, #ff5d00 99.66%);
              color: #fafafa;
            }
          }
        }

        .wheel-stage {
          position: relative;
          width: 355px;
          min-height: 320px;
          margin: 24px auto 0;

          .mayday-wheel-pan.wheel-pan {
            width: 315px;
            height: 315px;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url(./images/wheel-pan.webp) top left / 100% auto no-repeat;
            position: relative;
            z-index: 2;

            .outher {
              width: 245px;
              height: 245px;
              position: relative;
              border-radius: 50%;
              overflow: hidden;
              box-shadow: 0 4px 16px rgba(0, 129, 179, 0.2);

              .wapper {
                width: 246px;
                height: 246px;
                border-radius: 50%;

                .part1 {
                  position: absolute;
                  width: 123px;
                  height: 246px;
                  right: 0;
                  overflow: hidden;
                  text-align: center;

                  .text {
                    position: absolute;
                    top: 16px;
                    left: 11%;
                    transform: rotate(23deg);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }

                  .item {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    transform-origin: left center;
                  }

                  .item.one {
                    background-color: #fdd869;
                    z-index: 1;
                  }

                  .item.two {
                    background-color: #fcefcf;
                    transform: rotate(45deg);
                    z-index: 2;
                  }

                  .item.three {
                    background-color: #fdd869;
                    transform: rotate(90deg);
                    z-index: 3;
                  }

                  .item.four {
                    background-color: #fcefcf;
                    transform: rotate(135deg);
                    z-index: 4;
                  }
                }

                .part2 {
                  position: absolute;
                  width: 123px;
                  height: 246px;
                  left: 0;
                  overflow: hidden;

                  .text {
                    position: absolute;
                    top: 16px;
                    left: 57%;
                    transform: rotate(-24deg);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }

                  .item {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    transform-origin: right center;
                  }

                  .item.five {
                    background-color: #fdd869;
                    transform: rotate(-135deg);
                    z-index: 4;
                  }

                  .item.six {
                    background-color: #fcefcf;
                    transform: rotate(-90deg);
                    z-index: 3;
                  }

                  .item.seven {
                    background-color: #fdd869;
                    transform: rotate(-45deg);
                    z-index: 2;
                  }

                  .item.eight {
                    background-color: #fcefcf;
                    z-index: 1;
                  }
                }

                .part1,
                .part2 {
                  .gotted {
                    background: linear-gradient(180deg, #fe3740 0%, #fb7c2e 100%) !important;
                    .text {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      .text-tips {
                        color: #ffffff !important;
                      }
                    }
                  }
                }

                .text {
                  font-size: 0;
                  .text-tips {
                    min-height: 26px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: 'Inter-Tight', sans-serif;
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 20px;
                    color: #bf101f;
                  }

                  > img {
                    width: 36px;
                  }
                  > img.avatar-bar {
                    width: 30px;
                  }
                  > img.small-img {
                    width: 34px;
                  }
                }
              }
            }

            .mayday-wheel-pointer.wheel-pointer {
              position: absolute;
              top: 50%;
              left: 50%;
              z-index: 99;
              width: 40px;
              height: 52px;
              margin-top: -28px;
              margin-left: -20px;
              background: url(./images/pointer.webp) center / contain no-repeat;
            }
          }

          .podium-deco {
            pointer-events: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            margin-top: -40px;
            z-index: 0;

            .podium {
              width: 100%;
              max-width: 355px;
            }
          }
        }

        .ticket-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin: 4px 0 10px;
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 700;
          font-size: 16px;
          color: #353a3f;

          .tic {
            width: 32px;
            height: 32px;
          }

          .tic-div {
            width: 2px;
            height: 16px;
            background: #353a3f;
          }
        }

        .spin-btn-row {
          display: flex;
          justify-content: space-between;
          gap: 16px;
          padding: 8px 16px 16px;

          .spin-pill-wrap {
            position: relative;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: stretch;

            .spin-pill {
              position: relative;
              z-index: 2;
              border-radius: 12px;
              padding: 10px 8px 8px;
              text-align: center;

              .spin-pill-t {
                display: block;
                font-family: 'TikTokSans-Regular', sans-serif;
                font-weight: 900;
                font-size: 18px;
              }

              .spin-pill-sub {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                margin-top: 6px;
                padding: 0 8px;
                border-radius: 20px;
                background: rgba(255, 255, 255, 0.85);
                font-family: 'TikTokSans-Regular', sans-serif;
                font-weight: 900;
                font-size: 12px;

                .sub-tic {
                  width: 24px;
                  height: 24px;
                }
              }
            }

            .spin-pill-primary {
              color: #fff;
            }

            .silver-on {
              background: linear-gradient(181.1deg, #c01fff 1.6%, #820cff 97.77%);
              border-bottom: 0.5px solid #e998ff;
              .spin-pill-sub {
                color: #5f656a;
              }
            }
            .gold-on {
              background: linear-gradient(180deg, #ffa903 0.24%, #ff5d00 99.66%);
              border-bottom: 0.5px solid #feb358;
              .spin-pill-sub {
                color: #bf101f;
              }
            }
            .spin-off {
              background: linear-gradient(180.16deg, #e2e7f0 0.24%, #cdd7e2 99.66%) !important;
              border-bottom-color: #fff !important;
              .spin-pill-sub {
                color: #5f656a !important;
              }
            }

            .spin-pill-shadow {
              height: 28px;
              margin-top: -24px;
              border-radius: 12px;
              z-index: 1;
              &.silver {
                background: #6900d4;
              }
              &.gold {
                background: #ff5d00;
              }
              &.off {
                background: #95a3b8 !important;
              }
            }
          }
        }
      }

      .ways-card {
        .card-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;

          .card-head-left {
            display: flex;
            align-items: center;
            gap: 8px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 900;
            font-style: italic;
            font-size: 20px;
            line-height: 24px;
            color: #0081b3;

            .ic-star {
              width: 20px;
              height: 20px;
            }
          }
        }

        .ways-body {
          padding: 0 0 16px;

          .stats-bar {
            position: relative;
            display: flex;
            align-items: center;
            margin: 0 12px 16px;
            padding: 15px;
            min-height: 60px;
            background: #fff;
            border: 1px solid #cbf5ff;
            border-radius: 12px;

            .stats-left {
              display: flex;
              align-items: center;
              gap: 12px;

              .stat {
                display: flex;
                align-items: center;
                gap: 8px;
                font-family: 'TikTokSans-Regular', sans-serif;
                font-weight: 800;
                font-size: 18px;
                color: #202326;
                img {
                  width: 28px;
                  height: 28px;
                  object-fit: contain;
                }
              }
            }

            .stats-rank-link {
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              gap: 4px;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 700;
              font-size: 12px;
              color: #0081b3;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }

          .task-block {
            padding: 0 16px;

            &.task-block-daily {
              margin-bottom: 8px;
            }

            .task-block-title {
              margin: 0;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 700;
              font-size: 16px;
              color: #0081b3;
            }

            .task-block-sub {
              margin: 4px 0 12px;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 500;
              font-size: 12px;
              color: #5f656a;
            }

            .task-row {
              display: flex;
              align-items: stretch;
              gap: 8px;
              margin-bottom: 8px;
              padding: 12px 10px 8px;
              background: #fff;
              border: 1px solid #cbf5ff;
              border-radius: 12px;

              .task-row-main {
                flex: 1;
                min-width: 0;

                .task-desc {
                  font-size: 14px;
                  color: #202326;
                  .task-desc-proc {
                    color: #ff5171;
                  }
                }

                .task-desc-plain {
                  font-size: 14px;
                  line-height: 20px;
                  color: #202326;
                  display: flex;
                  align-items: center;
                }

                .task-row-reward {
                  margin-top: 6px;
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  gap: 10px;

                  .task-reward-item {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;

                    .task-reward-ic {
                      width: 28px;
                      height: 28px;
                      object-fit: contain;
                    }

                    > span {
                      font-family: 'TikTokSans-Regular', sans-serif;
                      font-size: 14px;
                      font-weight: 500;
                      color: #202326;
                    }
                  }
                }
              }

              .task-go {
                align-self: center;
                padding: 10px 20px;
                border-radius: 12px;
                border-bottom: 0.5px solid #feb358;
                background: linear-gradient(180.22deg, #ffa903 0.24%, #ff5171 99.66%);
                font-family: 'TikTokSans-Regular', sans-serif;
                font-weight: 600;
                font-size: 15px;
                color: #fff;
                white-space: nowrap;
              }

              .task-btn-wait {
                align-self: center;
                width: 88px;
                padding: 10px 5px;
                border-radius: 12px;
                background: #e2e7f0;
                font-family: 'TikTokSans-Regular', sans-serif;
                font-weight: 500;
                font-size: 15px;
                color: #a4a9bd;
                text-align: center;
                white-space: nowrap;
              }
            }

            .task-row-streak {
              .task-streak-done {
                align-self: center;
                padding: 10px 20px;
                border-radius: 12px;
                background: #edeef2;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                img {
                  width: 20px;
                  height: 20px;
                }
              }

              .task-streak-head {
                .streak-task-title {
                  display: block;
                  min-width: 0;
                }
              }

              .task-streak-bar-row {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 8px;

                .task-streak-bar {
                  width: 120px;
                  height: 6px;
                  border-radius: 3px;
                  border: 0.5px solid #ffdabc;
                  background: #fff0d4;
                  overflow: hidden;

                  .task-streak-bar-fill {
                    height: 100%;
                    border-radius: 3px;
                    background: #ffa903;
                    transition: width 0.2s ease;
                  }
                }

                .task-streak-progress {
                  flex-shrink: 0;
                  font-family: 'TikTokSans-Regular', sans-serif;
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 20px;
                  color: #ff5171;

                  &.is-done {
                    color: #9aa4ad;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .act-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    box-sizing: border-box;

    .dia-bg {
      width: 315px;
      max-width: 100%;
      border-radius: 16px;

      .con-block {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding-bottom: 20px;
        border-radius: 16px;
        border: 2px solid #fff;
        background: #d3f6ff;
        overflow: hidden;

        .gifts-dia-head {
          position: relative;
          width: 100%;
          min-height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 16px 0;
          box-sizing: border-box;

          span {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            color: #0081b3;
            text-align: center;
          }
        }

        /* 单抽 Figma 2759:24964 */
        .gifts-reward1 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 16px;
          box-sizing: border-box;

          .gifts-reward1-cell {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
          }

          .img-wrap {
            width: 70px;
            height: 70px;
            border-radius: 8px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            img {
              max-width: 60px;
              max-height: 60px;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            .avatar-bar {
              max-width: 60px;
              max-height: 60px;
            }
          }

          .rewards-count {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-style: italic;
            font-size: 12px;
            line-height: normal;
            color: #0081b3;
            text-align: center;
          }
        }

        /* 十连 Figma 2759:23586 */
        .gifts-reward2 {
          width: 100%;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 10px 6px;
          padding: 16px 24px 8px;
        }

        .gifts-reward2-cell {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          min-width: 0;

          .img-wrap {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            img {
              max-width: 36px;
              max-height: 36px;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            .avatar-bar {
              max-width: 36px;
              max-height: 36px;
            }
          }

          .rewards-count {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-style: italic;
            font-size: 12px;
            line-height: normal;
            color: #0081b3;
            text-align: center;
            width: 100%;
          }

          &.gifts-reward2-cell--stagger {
            opacity: 0;
            animation: mayday-reward-pop 0.2s ease-out forwards;
          }
        }

        .gifts-confirm {
          width: 275px;
          max-width: calc(100% - 32px);
          height: 52px;
          margin: 0 auto;
          padding: 10px 24px;
          box-sizing: border-box;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(180deg, #82e1fd 0.36%, #55b9fe 99.64%);
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;

          span {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 600;
            font-size: 20px;
            line-height: normal;
            color: #013d54;
            text-align: center;
          }

          &:active {
            opacity: 0.92;
          }
        }
      }
    }
  }
}

@keyframes mayday-reward-pop {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .mayday-root .mayday-main .mayday-hero-bg {
    transform: translateX(-50%) rotateY(180deg);
  }
  .mayday-root .mayday-scroll .ways-card .ways-body .stats-bar .stats-rank-link {
    right: unset;
    left: 12px;
  }
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-go,
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-btn-wait,
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-streak-done {
    margin-left: 8px;
  }
  .mayday-root .mayday-main .mayday-scroll .ways-card .ways-body .stats-bar .stats-rank-link img {
    transform: rotateY(180deg);
  }
}
</style>

<style>
.act-mayday-bean {
  width: 36px;
  height: 36px;
}
</style>
